module.exports = "pegasus/assets/theme3/twitter-icon-1.png";